<ng-container *ngIf="baseUrl; else notHyperLink">
  <a class="fw-semibold text-neutral-900" [routerLink]="url" (click)="onClick()">{{value}}</a>
</ng-container>

<ng-template #notHyperLink>
  <p class="fw-semibold text-neutral-900">{{value}}</p>
</ng-template>

